module.exports = __webpack_public_path__ + "data/650f3ee.japan.prefectures.geo.json";